// imports section Start
import React from "react";
import { useTheme } from "@mui/material/styles";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import RoomServiceIcon from "@mui/icons-material/RoomService";
import { useStyles } from "../../assets/styles/Theme";
import { Card, Grid, Typography, Button, IconButton } from "@mui/material";
import { formatDate, formatTime } from "../../utils/common/DateFormat";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import { currencyFormat } from "../../utils/common/CurrencyFormat";

// imports section End

const CheffItems = ({ placedorderItem, onDeleteOrder, onUpdateOrder }) => {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  // Hooks end

  // Handlers start
  const formattedDate = formatDate(placedorderItem.ENDATE);
  const formattedTime = formatTime(placedorderItem.ORDERTIME);
  const formattedAmount = currencyFormat(
    placedorderItem.AMOUNT,
    placedorderItem.PREFCURRENCY
  );
  // Handlers end

  return (
    <Card sx={styles.po_card}>
      <Grid
        sx={{
          borderLeft: `4px solid #28B411`,
          paddingLeft: "8px",
        }}
      >
        <Grid sx={styles.po_card_content}>
          <Typography sx={styles.po_card_texts}>
            #{placedorderItem.ORDERCODE}
          </Typography>
          <Typography
            sx={{
              //   ...styles.po_card_id,
              color: theme.palette.input_field.text,
              fontSize: "14px",
              fontWeight: 600,
              lineHeight: "130%",
            }}
          >
            {formattedAmount}
          </Typography>
        </Grid>
        <Grid
          sx={{
            ...styles.po_card_content,
          }}
        >
          <Typography
            sx={{
              ...styles.po_card_texts,
              fontSize: "14px",
              fontWeight: 600,
              lineHeight: "130%",
            }}
          >
            {placedorderItem.ENUSER}
          </Typography>
          <Typography
            sx={{
              ...styles.po_card_texts,
              fontSize: "12px",
              fontWeight: 600,
              lineHeight: "130%",
            }}
          >
            <IconButton sx={styles.po_card_icons}>
              <CalendarMonthIcon />
            </IconButton>
            {formattedDate}
          </Typography>
        </Grid>
      </Grid>

      <Grid
        container
        sx={{
          ...styles.po_card_content,
          borderTop: `1px solid ${theme.palette.stroke.main}`,
          //   borderRadius: 0,
          pt: 2,
          mt: 1,
        }}
      >
        <Grid item sx={styles.cheff_card_grid}>
          <Button
            sx={styles.btn_secondary}
            size="medium"
            variant="outlined"
            onClick={onDeleteOrder}
          >
            Cancel
          </Button>
          <Button
            sx={styles.btn_primary}
            size="medium"
            variant="contained"
            onClick={onUpdateOrder}
          >
            Approve
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
};

export default CheffItems;
